<template>
  <div>
    <el-dialog :visible="show" @close="$emit('close')">
      <div class="title flex items-center space-x-8">
        <span>{{ $t('选择商品') }}</span>
        <search :placeholder="$t('商品名称/关键词')" @search="search"></search>
      </div>
      <div class="list cursor-pointer" v-for="item in pager.items" :key="item.id" @click="getCurPProduct(item)">
        <img :src="$firstImage(item.images, 'small')">
        <span class="text-base">{{ item.name }}</span>
        <span class="text-sm text-gray-400">{{ item.classify_text }}</span>
      </div>
      <el-pagination background layout="prev, pager, next" :total="pager.total" :page-size="pager.size"
        @current-change="pageChange">
      </el-pagination>
    </el-dialog>

  </div>
</template>
<script>
import Search from "@/components/mine/search.vue";
import { watchEffect, computed, ref, reactive, watch } from "@vue/composition-api";
export default {
  props: { show: Boolean },
  components: { Search },
  setup(props, ctx) {
    const keyword = ref('')
    const param = computed(() => {
      if (keyword.value) {
        return {
          q__name__contains: keyword.value
        }
      } else {
        return {}
      }
    })
    const pager = ref(
      new ctx.root.$Pager({
        apiname: 'sup/getPProducts',
        size: 8,
        param: () => (param.value)
      })
    )

    watchEffect(async () => {
      if (props.show) {
        await pager.value.first()
      }
    })

    const pageChange = async (val) => {
      await pager.value.load(val)
    }

    const showDetail = ref(false)
    const closeDetail = () => {
      if (showDetail.value) {
        showDetail.value = false
      } else {
        ctx.$emit('productClose')
      }
    }
    const getCurPProduct = (item) => {
      ctx.emit('getCurPProduct', JSON.stringify(item))
    }
    const search = async (val) => {
      keyword.value = val
      await pager.value.first()
    }
    return { pager, pageChange, showDetail, closeDetail, getCurPProduct, keyword, search }

  }
}
</script>
<style scoped lang="scss">
.list {
  display: grid;
  grid-template-columns: 2.938rem auto;
  grid-column-gap: 0.688rem;
  text-align: left;
  margin-top: 1.5rem;
}
.list img {
  grid-row: 1/3;
  border-radius: 0.25rem;
}
.title {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.title.require::before {
  content: '*';
  color: #FF4142;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
</style>